import axios from "../axiosInstance";
import { FetchQuickBooksReportsLastSyncResponse } from "./types";

export const fetchQuickBooksReportsLastSync =
  async (): Promise<FetchQuickBooksReportsLastSyncResponse> => {
    const response = await axios.get<FetchQuickBooksReportsLastSyncResponse>(
      "/api/private/quickbooks-reports/last-sync",
    );
    return response.data;
  };
